import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import Footer from "./Footer";
import Navbar from "./Navbar_old";
import { Helmet } from "react-helmet";
import apiService from "../services/apiService";

const Moredetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();

  const loggedUser = JSON.parse(localStorage.getItem("currentUser")) || null; // ✅ ADDED

  const stateUser = location.state || null;
  const [user, setUser] = useState(stateUser || {});


useEffect(() => {
  if (!loggedUser) {
    navigate("/login", { replace: true });
  }
}, [loggedUser, navigate]);

  // 🔐 Current viewer (logged in user)
  const currentUser = {
    id: loggedUser?.id || 0,
    fullName: loggedUser?.full_name || loggedUser?.name || "Guest",
    canChat: loggedUser?.can_chat || false,
    canCall: loggedUser?.can_call || false,
  };

  // Fetch user from backend
  useEffect(() => {
    if (!id) return;
    apiService.getUser(id)
      .then((data) => {
        if (data.success && data.user) setUser(data.user);
      })
      .catch((err) => console.error("Fetch error:", err));
  }, [id]);

  // Profile image safe handling
 const defaultAvatar = "https://cdn-icons-png.flaticon.com/512/149/149071.png";

const profileImage = (() => {
  if (!user?.image || user.image.trim() === "") return defaultAvatar;
  return apiService.getImageUrl(user.image) || defaultAvatar;
})();


  const profile = {
    name: user?.full_name || user?.fullName || user?.name || "Not Filled",
    id: user?._id || user?.id || "Not Assigned",
    image: profileImage,
    age: user?.age || "Not Filled",
    height: user?.height || "Not Filled",
    profession: user?.profession || "Not Filled",
    location: `${user?.city || "Not Filled"}, ${user?.user_state || "Not Filled"}`,
  };

  const renderSection = (title, items) => (
    <div
      className="mb-5 p-3 rounded-3"
      style={{
        background:
          "linear-gradient(315deg, rgba(172,119,41,0.9), rgba(195,94,57,1))",
        color: "white",
        boxShadow: "0 6px 18px rgba(0,0,0,0.25)",
        backdropFilter: "blur(8px)",
      }}
    >
      <h6 className="fw-bold mb-3 border-bottom pb-2">
        <i className="bi bi-folder2-open me-2"></i> {title}
      </h6>
      <div className="row">
        {items.map((item, idx) => (
          <div className="col-12 col-md-6 mb-2" key={idx}>
            <div className="d-flex align-items-center">
              <i className={`${item.icon} me-2`} style={{ color: "#ffdf91" }}></i>
              <strong className="me-1">{item.label}:</strong>
              <span style={{ opacity: 0.9 }}>
                {item.value || item.info || "Not Filled"}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const personalDetails = [
    { label: "Marital Status", icon: "bi-people", value: user?.marital_status },
    { label: "Gender", icon: "bi-gender-male", value: user?.gender },
    { label: "Color", icon: "bi-droplet", value: user?.color },
    { label: "Age", icon: "bi-egg", value: user?.age },
    { label: "Height", icon: "bi-rulers", value: user?.height },
    { label: "Weight", icon: "bi-barbell", value: user?.weight },
    { label: "Diet", icon: "bi-egg-fried", value: user?.diet },
    { label: "Disability", icon: "bi-toggle-on", value: user?.disability },
    { label: "Blood Group", icon: "bi-circle-fill", value: user?.blood_group },
    { label: "Profile Created By", icon: "bi-person-circle", value: user?.profile_created_by },
    { label: "Country", icon: "bi-flag", value: user?.country },
    { label: "State", icon: "bi-compass", value: user?.user_state },
    { label: "City", icon: "bi-map", value: user?.city },
    { label: "Town", icon: "bi-key", value: user?.town },
  ];

  const careerDetails = [
    { label: "Education", icon: "bi-award", value: user?.education },
    { label: "Education Detail", icon: "bi-info-circle", value: user?.education_detail },
    { label: "Profession", icon: "bi-person-badge", value: user?.profession },
    { label: "Occupation", icon: "bi-briefcase", value: user?.occupation },
    { label: "Occupation Detail", icon: "bi-info-circle", value: user?.occupation_detail },
    { label: "Annual Income", icon: "bi-wallet2", value: user?.income },
  ];

  const familyDetails = [
    { label: "Father's Name", icon: "bi-person", value: user?.father_name },
    { label: "Father's Occupation", icon: "bi-briefcase", value: user?.father_occupation },
    { label: "Mother's Name", icon: "bi-person-circle", value: user?.mother_name },
    { label: "Mother's Occupation", icon: "bi-briefcase", value: user?.mother_occupation },
    { label: "Married Brothers", icon: "bi-people-fill", value: user?.married_brothers },
    { label: "Unmarried Brothers", icon: "bi-people", value: user?.unmarried_brothers },
    { label: "Married Sisters", icon: "bi-people-fill", value: user?.married_sisters },
    { label: "Unmarried Sisters", icon: "bi-people", value: user?.unmarried_sisters },
    { label: "House", icon: "bi-house", value: user?.house },
    { label: "Car", icon: "bi-car-front", value: user?.car },
  ];
  <Helmet>

  <meta
    property="og:url"
    content={`https://rishteymatch.in/moredetail/${profile.id}`}
  />
</Helmet>

  // 🔐 Contact section with permission
  const contacts = [
    { label: "Mobile No", icon: "bi-telephone", info: currentUser.canCall ? user?.mobile : "🔒 Upgrade to view" },
    { label: "Father’s Contact No", icon: "bi-telephone", info: currentUser.canCall ? user?.father_contact : "🔒 Upgrade to view" },
    { label: "Whatsapp No", icon: "bi-whatsapp", info: currentUser.canChat ? user?.whatsapp : "🔒 Upgrade to view" },
    { label: "Email", icon: "bi-envelope", info: currentUser.canChat ? user?.email : "🔒 Upgrade to view" },
    { label: "Present Address", icon: "bi-geo-alt", info: currentUser.canChat ? user?.present_address : "🔒 Upgrade to view" },
    { label: "Permanent Address", icon: "bi-key", info: currentUser.canChat ? user?.permanent_address : "🔒 Upgrade to view" },
  ];

  return (
    <>
      <Navbar />
      <div className="container py-4" style={{ color: "white", minHeight: "100vh", background: "linear-gradient(315deg, rgb(202 155 70), rgb(212 108 70))" }}>
        <button onClick={() => navigate(-1)} className="btn btn-light mb-3">← Back</button>

        <div className="p-4 rounded-4 shadow-lg mb-4 d-flex flex-column flex-md-row align-items-center"
          style={{
            background: "linear-gradient(135deg, rgba(205,153,63,0.95), rgba(215,95,52,0.95))",
            border: "2px solid rgba(255,255,255,0.2)",
            boxShadow: "0 8px 20px rgba(0,0,0,0.3)",
            backdropFilter: "blur(8px)",
          }}
        >
          <img
            src={profile.image}
            alt={profile.name}
            onError={(e) => (e.target.src = defaultAvatar)}
            className="me-md-4 mb-3 mb-md-0"
            width="300"
            height="300"
            style={{ objectFit: "cover", borderRadius: "12px", border: "2px solid white" }}
          />
          <div className="text-start text-md-start">
            <h4 className="fw-bold mb-1">{profile.name}</h4>
            {/* <p className="mb-1">Profile ID: {profile.id}</p> */}
            <p className="mb-1">profession : {profile.profession}</p>
            <p className="mb-1">height : {profile.height}</p>
            <p className="mb-0"><i className="bi bi-geo-alt me-1"></i>{profile.location}</p>
          </div>
        </div>

        {renderSection("Personal Details", personalDetails)}
        {renderSection("Career Details", careerDetails)}
        {renderSection("Family Details", familyDetails)}
        {renderSection("Contact Details", contacts)}
      </div>
      <Footer />
    </>
  );
};

export default Moredetail;
